// extracted by mini-css-extract-plugin
export default {"container":"N87p3iJ4","messageBox":"y22ygK5g","name":"miiqkbFA","message":"eYmMy82W","сharacterImg":"fjhGbw4T","buttonNext":"sOtEJmSl"};
    if(module.hot) {
      // 1717522983104
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  